(function () {
  'use strict';

  /* @ngdoc object
   * @name template
   * @description
   *
   */
  angular
    .module('template', [
      'ui.router'
    ]);
}());
